<template>
  <div class="field">
    <label class="label">
      {{label}}
      <b-icon pack="fas" icon="star" class="fa-ss" v-show="required"></b-icon>
    </label>
    <div class="control is-flex">
      <multiselect @select="$markDirty()"
      :showLabels="false"
      :name="instanceName"
      :key="instanceName"
      tagPosition="bottom"
      :searchable="true"
      :hideSelected="true"
      :disabled="isDisabled"
      data-vv-validate-on="input|close"
      :data-vv-as="this.validateAs"
      v-validate="{ 'required': required }"
      :class="{ 'is-danger': errors.has(validationName) }"
      v-model="selectedCustomer"
      :options="allCustomers"
      label="fullName"
      trackBy="id"
      :loading="isCustomerLoading"
      placeholder="Type to search for a customer"
      :internal-search="false"
      :options-limit="300"
      @search-change="onCustomerSearch"
      :data-vv-scope="scope"
      ref="selector">
        <template slot="beforeList">
          <div class="columns is-multiline is-mobile" style="margin:1px">
            <div class="column is-4">
              <label class="has-text-weight-bold">Name</label>
            </div>
          </div>
        </template>
      </multiselect>
    </div>
    <span v-show="errors.has(validationName)" class="help is-danger"><i v-show="errors.has(validationName)" class="fas fa-exclamation-triangle"></i> {{ errors.first(validationName) }}</span>
    <br/>
  </div>
</template>

<script>

import _ from 'lodash'
import customerService from '@/services/customerService'

export default {
  inject: {
    $validator: '$validator'
  },
  name: 'CustomerSelector',
  props: {
    value: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: 'Customer'
    },
    validateAs: {
      type: String,
      default: 'customer'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    dealerId: {
      type: Number,
      default: null
    },
    scope: {
      type: String,
      default: null
    },
    useValidator: {
      type: Object,
      default: null
    }
  },
  components: {
  },
  data () {
    return {
      isCustomerLoading: false,
      selectedCustomer: this.value,
      data: [],
      instanceName: 'customer-selector-' + this.$uuid.v4(),
      includeActiveCustomers: false
    }
  },
  computed: {
    allCustomers () {
      return this.data
    },
    validationName: function () {
      return this.scope ? this.scope + '.' + this.instanceName : this.instanceName
    },
    selectedCustomerId: function () {
      return this.selectedCustomer ? this.selectedCustomer.id : 0
    }
  },
  watch: {
    selectedCustomer: async function (newValue, oldValue) {
      this.$emit('input', newValue)
    },
    value: function (newValue, oldValue) {
      this.selectedCustomer = newValue
      if (newValue) {
        this.data.push(newValue)
      }
    }
  },
  methods: {
    clearAllCustomers () {
      this.data = []
    },
    loadAsyncData: function (query) {
      var searchCommand = {
        page: 0,
        pageSize: 100,
        query: query,
        dealerId: this.dealerId,
        sortBy: 'firstName.asc',
        requiresStatistics: false,
        showRejectedCustomers: this.rejected,
        includeActiveCustomers: this.includeActiveCustomers
      }
      this.isCustomerLoading = true
      this.clearAllCustomers()
      customerService.all(searchCommand).then(response => {
        this.data = response.results || response
        this.isCustomerLoading = false
      })
    },
    doCustomerSearch: _.debounce(function (query) { this.loadAsyncData(query) }, 500),
    onCustomerSearch (query) {
      if (!query || query === '') {
        return
      }
      this.doCustomerSearch(query)
    }
  },
  created: function () {
    if (this.useValidator) {
      this.$validator = this.useValidator
    }
  }
}

</script>

<style scoped>
  .new-customer-btn {
    margin-left:5px;
    height:40px;
  }

</style>
